import { BORDER_RADIUS, BOX_SHADOW, COLORS, FONTS, LAYOUT, SPACING } from './themeConf';
import { createTheme } from '@material-ui/core/styles';
import { border, toCssValue } from '../themeUtils';
const themeConf = {
    color: {
        primary: {
            lightest: COLORS.primary.lightest,
            light: COLORS.primary.light,
            main: COLORS.primary.main,
            dark: COLORS.primary.dark,
            darkest: COLORS.primary.darkest,
        },
        brand: {
            lightest: COLORS.brand.lightest,
            light: COLORS.brand.light,
            main: COLORS.brand.main,
            dark: COLORS.brand.dark,
            darkest: COLORS.brand.darkest,
        },
        success: {
            light: COLORS.success.light,
            main: COLORS.success.main,
            dark: COLORS.success.dark,
        },
        error: {
            lightest: COLORS.error.lightest,
            light: COLORS.error.light,
            main: COLORS.error.main,
            dark: COLORS.error.dark,
        },
        warning: {
            lightest: COLORS.warning.lightest,
            light: COLORS.warning.light,
            main: COLORS.warning.main,
        },
        grey: {
            lightest: COLORS.grey.lightest,
            light: COLORS.grey.light,
            default: COLORS.grey.default,
            dark: COLORS.grey.dark,
            darkest: COLORS.grey.darkest,
        },
        input: {
            placeholder: COLORS.grey.default,
            border: COLORS.grey.default,
        },
        background: {
            body: COLORS.background.body,
            light: COLORS.background.light,
            dark: COLORS.background.dark,
        },
        font: {
            dark: COLORS.font.dark,
            light: COLORS.font.light,
        },
        common: {
            contentHover: COLORS.common.contentHover,
        },
    },
    font: {
        family: FONTS.family,
        size: {
            small: FONTS.size.small,
            mediumSmall: FONTS.size.mediumSmall,
            medium: FONTS.size.medium,
            mediumBig: FONTS.size.mediumBig,
            big: FONTS.size.big,
            caption: FONTS.size.caption,
            title: FONTS.size.title,
            heading: FONTS.size.heading,
        },
        lineHeight: {
            small: FONTS.lineHeight.small,
            mediumSmall: FONTS.lineHeight.mediumSmall,
            medium: FONTS.lineHeight.medium,
            mediumBig: FONTS.lineHeight.mediumBig,
            big: FONTS.lineHeight.big,
        },
        weight: {
            light: FONTS.weight.light,
            normal: FONTS.weight.normal,
            bold: FONTS.weight.bold,
        },
    },
    common: {
        borderRadius: {
            low: BORDER_RADIUS.low,
            default: BORDER_RADIUS.default,
            high: BORDER_RADIUS.high,
            onlyTop: BORDER_RADIUS.onlyTop,
            onlyRight: BORDER_RADIUS.onlyRight,
        },
        shadow: {
            light: BOX_SHADOW.light,
            default: BOX_SHADOW.default,
            dark: BOX_SHADOW.dark,
        },
    },
    space: {
        layout: {
            fullWidth: SPACING.layout.fullWidth,
            partialWidth: SPACING.layout.partialWidth,
        },
        margin: {
            smallest: SPACING.margin.smallest,
            small: SPACING.margin.small,
            default: SPACING.margin.default,
            large: SPACING.margin.large,
            largest: SPACING.margin.largest,
            horizontalDefault: SPACING.margin.horizontalDefault,
            verticalDefault: SPACING.margin.verticalDefault,
        },
        padding: {
            smallest: SPACING.padding.smallest,
            small: SPACING.padding.small,
            default: SPACING.padding.default,
            large: SPACING.padding.large,
            largest: SPACING.padding.largest,
            horizontalDefault: SPACING.padding.horizontalDefault,
            verticalDefault: SPACING.padding.verticalDefault,
        },
    },
    layout: {
        width: {
            full: LAYOUT.width.full,
            partial: LAYOUT.width.partial,
        },
        sidebar: {
            full: LAYOUT.sidebar.full,
        },
        header: {
            topBar: LAYOUT.header.topBar,
            menu: LAYOUT.header.menu,
        },
    },
    components: {
        table: {
            header: {
                background: COLORS.brand.main,
                color: COLORS.font.light,
            },
            headerSecondary: {
                background: COLORS.brand.main,
                color: COLORS.font.light,
            },
            th: {
                background: COLORS.background.light,
                color: COLORS.font.dark,
            },
            row: {
                hover: COLORS.common.contentHover,
            },
        },
        link: {
            colors: {
                normal: COLORS.brand.main,
                hover: COLORS.brand.light,
            },
        },
        header: {
            colors: {
                background: COLORS.brand.main,
                text: COLORS.font.light,
                menuIcon: COLORS.font.light,
            },
        },
        menu: {
            colors: {
                background: COLORS.background.light,
                text: COLORS.font.dark,
                selected: COLORS.brand.main,
            },
        },
        userMenu: {
            colors: {
                headerBackground: COLORS.primary.light,
                headerText: COLORS.font.dark,
                buttonBackground: COLORS.background.light,
                buttonText: COLORS.font.dark,
                buttonBackgroundHover: COLORS.primary.main,
                triggerBackground: COLORS.background.light,
                triggerText: COLORS.brand.main,
                userIconBackground: COLORS.primary.darkest,
                userIconText: COLORS.font.light,
            },
        },
        tabs: {
            indicator: COLORS.background.light,
            background: COLORS.brand.main,
            color: COLORS.font.light,
        },
        listItem: {
            backgroundHover: COLORS.background.light,
            backgroundSelected: COLORS.primary.main,
            textHover: COLORS.font.dark,
            textSelected: COLORS.font.light,
        },
        sidebar: {
            colors: {
                itemSelected: COLORS.brand.main,
                border: COLORS.brand.main,
            },
        },
        passwordSuggestionBox: {
            container: {
                background: COLORS.background.light,
                text: COLORS.font.dark,
            },
            arrow: {
                background: COLORS.background.light,
            },
            rule: {
                iconSuccess: COLORS.success.main,
                iconError: COLORS.error.main,
                text: COLORS.font.dark,
            },
        },
        logoutButton: {
            background: COLORS.grey.lightest,
            backgroundHover: COLORS.grey.light,
            text: COLORS.font.dark,
        },
    },
};
export function createMyTheme(options) {
    return createTheme({
        palette: {
            primary: {
                light: COLORS.primary.light,
                main: COLORS.primary.main,
                dark: COLORS.primary.dark,
            },
            secondary: {
                light: COLORS.brand.light,
                main: COLORS.brand.main,
                dark: COLORS.brand.dark,
            },
            text: {
                primary: COLORS.font.dark,
                secondary: COLORS.font.light,
            },
        },
        typography: {
            fontFamily: FONTS.family,
            h5: {
                fontSize: '1.25rem',
                lineHeight: '1.5',
            },
            subtitle1: {
                lineHeight: '1.25',
            },
            body1: {
                color: '#4a4a4a',
            },
            caption: {
                color: '#333',
                fontSize: '0.625rem',
            },
            h4: {
                fontSize: '1.5rem',
                fontWeight: 500,
                color: 'black',
            },
        },
        overrides: {
            MuiAutocomplete: {
                noOptions: {
                    color: COLORS.font.dark,
                    fontSize: FONTS.size.medium,
                },
            },
            MuiInput: {
                underline: {
                    '&:after, &:before': {
                        borderBottom: border('currentColor'),
                    },
                    '&:hover:not($disabled):not($focused):not($error):before': {
                        borderBottomColor: 'currentColor',
                    },
                },
            },
            MuiFormHelperText: {
                root: {
                    marginTop: 2,
                    fontSize: '0.70rem',
                    lineHeight: '0.9em',
                },
            },
            MuiFormLabel: {
                root: {
                    color: COLORS.grey.light,
                    '&$disabled': {
                        color: COLORS.font.dark,
                    },
                    '&$focused': {
                        color: COLORS.font.dark,
                    },
                },
            },
            MuiInputLabel: {
                formControl: {
                    color: COLORS.font.dark,
                },
            },
            MuiStepLabel: {
                root: {
                    textTransform: 'uppercase',
                },
                label: {
                    color: COLORS.font.dark,
                },
                completed: {
                    '&:hover': {
                        cursor: 'pointer',
                        textDecoration: 'underline',
                    },
                },
                active: {
                    fontWeight: `${FONTS.weight.bold} !important`,
                },
                '&$disabled': {
                    color: COLORS.grey.light,
                },
            },
            MuiStepIcon: {
                root: {
                    '& text': {
                        fill: COLORS.font.light,
                        fontSize: FONTS.size.mediumSmall,
                        fontWeight: FONTS.weight.bold,
                    },
                },
                completed: {
                    color: `${COLORS.primary.main} !important`,
                },
                active: {
                    color: `${COLORS.primary.main} !important`,
                },
            },
            MuiInputBase: {
                input: {
                    padding: toCssValue([7, 0, 2]),
                    fontSize: FONTS.size.mediumBig,
                },
            },
            MuiRadio: {
                root: {
                    color: COLORS.font.dark,
                },
            },
            MuiSelect: {
                select: {
                    padding: toCssValue([7, 0, 6]),
                },
            },
        },
        ...options,
    });
}
export const theme = createMyTheme(themeConf);
//# sourceMappingURL=theme.js.map